import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import User from 'EurestoClass/User'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import project from 'EurestoConfig/project.config'
import React, { useEffect, useState } from 'react'
import Sellsy from '../../../../Configuration/Component/Interface/Sellsy'


export default React.memo(props => {

  const isStatAvailable = (User.User.get().id === 2 || User.User.get().id === 8 || User.User.get().id === 32820)

  const [stats, setStats] = useState(null)

  if (isStatAvailable) {
    useEffect(() => {
      getStatsEtablissement()
        .then(s => setStats(s))
    }, [])
  }

  const getStatsEtablissement = async () => {
    const result = await ApiRequest(project.api + 'interface/sellsy', {
      action: 'get',
      requete: 'statistique',
    }, { showAlertError: false })

    return result && result.results || null
  }

  return (
    <Grid item style={{ margin: 0, padding: 10 }} xs={12}>
      <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
        {isStatAvailable && <Grid item style={{ margin: 0, padding: 10 }} xs={12} md={4} lg={2}>
          <EurestoDiv fullTitle titleStyle={{ padding: 0 }} title={'Sur les 12 derniers mois'}
                      style={{ padding: '10px 0 0 0' }}>
            {
              stats && <React.Fragment>
                <Grid container wrap={'nowrap'} direction={'column'} justify={'center'} alignItems={'stretch'}
                      alignContent={'center'} style={{ padding: 0, margin: 0, borderBottom: '1px solid lightgray' }}>
                  <h3 style={{ padding: '0 5px', margin: 0 }}
                      className={'EurestoPrimary--text'}>{stats.chiffre_affaire.label} ({stats.chiffre_affaire.unit})</h3>
                  <h2 style={{ textAlign: 'center', padding: '0 5px', margin: 0 }}
                      className={'EurestoPrimary--text'}>{stats.chiffre_affaire.value_label}</h2>
                </Grid>
                <Grid container wrap={'nowrap'} direction={'column'} justify={'center'} alignItems={'stretch'}
                      alignContent={'center'} style={{ padding: 0, margin: 0, borderBottom: '1px solid lightgray' }}>
                  <h3 style={{ padding: '0 5px', margin: 0 }}
                      className={'EurestoError--text'}>{stats.factures_attentes.label} ({stats.factures_attentes.unit})</h3>
                  <h2 style={{ textAlign: 'center', padding: '0 5px', margin: 0 }}
                      className={'EurestoError--text'}>{stats.factures_attentes.value_label}</h2>
                  <h5 style={{
                    textAlign: 'center',
                    padding: '0 5px',
                    margin: 0,
                    color: 'grey'
                  }}>{stats.factures_attentes.nb}</h5>
                </Grid>
                <Grid container wrap={'nowrap'} direction={'column'} justify={'center'} alignItems={'stretch'}
                      alignContent={'center'} style={{ padding: 0, margin: 0, borderBottom: '1px solid lightgray' }}>
                  <h3 style={{ padding: '0 5px', margin: 0 }}
                      className={'EurestoSecondary--text'}>{stats.devis_acceptes.label} ({stats.devis_acceptes.unit})</h3>
                  <h2 style={{ textAlign: 'center', padding: '0 5px', margin: 0 }}
                      className={'EurestoSecondary--text'}>{stats.devis_acceptes.value_label}</h2>
                  <h5 style={{
                    textAlign: 'center',
                    padding: '0 5px',
                    margin: 0,
                    color: 'grey'
                  }}>{stats.devis_acceptes.nb}</h5>
                </Grid>
                <Grid container wrap={'nowrap'} direction={'column'} justify={'center'} alignItems={'stretch'}
                      alignContent={'center'} style={{ padding: 0, margin: 0 }}>
                  <h3 style={{ padding: '0 5px', margin: 0, color: 'orange' }}>{stats.devis_attentes.label} ({stats.devis_attentes.unit})</h3>
                  <h2 style={{
                    textAlign: 'center',
                    padding: '0 5px',
                    margin: 0,
                    color: 'orange'
                  }}>{stats.devis_attentes.value_label}</h2>
                  <h5 style={{
                    textAlign: 'center',
                    padding: '0 5px',
                    margin: 0,
                    color: 'grey'
                  }}>{stats.devis_attentes.nb}</h5>
                </Grid>
              </React.Fragment>
            }
          </EurestoDiv>
        </Grid>}
        <Grid item style={{ margin: 0, padding: 10 }} xs={12} md={isStatAvailable && 8 || 12} lg={isStatAvailable && 10 || 12}>
          <Sellsy showSearch
                  showContactLibelle
                  isAllow={{}}
                  title={'Documents Sellsy'}
                  searchName={'document_sellsy_dashboard_'}
                  maxHeight={'300px'}
                  defaultSearch={{
                    '?type': 'invoice'
                  }}/>
        </Grid>
      </Grid>
    </Grid>
  )
})



// WEBPACK FOOTER //
// ./app/App/Module/Home/Component/Widgets/Sellsy/index.js